module.exports = __webpack_public_path__ + "img/beam.bc93dd30.svg";